import { createContext, useContext, useEffect, useReducer, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import AuthService from "../api/auth";
import { CookiesArray, CookiesList } from "../constants/cookies";

const initialState = {
  initialized: false,
  authenticated: null,
  user: null,
  conversation: null,
  open_popups: {
    show_start_project: false,
    show_join_newsletter: false,
    show_cookies: false
  },
  force_open_get_quote: false,
  page_scroll: null,
  navigation_mode: null
};

const handlers = {
  INITIALIZE: (state, action) => ({
    ...state,
    ...action.payload,
    initialized: true,
  }),
  DATA: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  ASK: (state, action) => ({
    ...state,
    conversation: action.payload,
  }),
  SET_POPUPS: (state, action) => ({
    ...state,
    open_popups: {
      ...state.open_popups,
      ...action.payload
    }
  }),
  SET_PAGESCROLL: (state, action) => ({
    ...state,
    page_scroll: action.page_scroll
  }),
  SET_NAV_MODE: (state, action) => ({
    ...state,
    navigation_mode: action.payload.navigation_mode
  })
};

const reducer = (state, action) => handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  saveAccessToken: (token) => {},
  logout: (redirect) => {},
  askApi: (data, question, questionType) => {},
});

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [cookies, setCookie, removeCookie] = useCookies(CookiesArray);

  const popupsRef = useRef({
    showNewsletter: false,
    showStartProject: false,
  })

  const [popups, setPopups] = useState({
    showNewsletter: false,
    showStartProject: false,
    showCookies: false,
  });

  var req_controllers = {
    me: null,
  };

  useEffect(() => {
    console.log("initializing authctx");

    checkAndSetPopups(['cookie']);

    // getUser().then((data) => {
      dispatch({
        type: "INITIALIZE",
        payload: {
          ...({}),
        },
      // });
    });

    const handleUserInteraction = (e) => {

      const scrollPosition = window.pageYOffset;
      const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollPosition / windowHeight) * 100;

      // console.log("scrollPercentage :: ", scrollPercentage);
      if (scrollPercentage > 35) {
        // console.log("PopupsRef :: ", popupsRef.current)
        if(popupsRef.current.showNewsletter === false) {
          checkAndSetPopups(['newsletter']);
        }
      }

    };

    window.addEventListener('click', handleUserInteraction);
    window.addEventListener('scroll', handleUserInteraction);

    return () => {
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('scroll', handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    console.log("Popups :: ", popups)
    popupsRef.current = popups;
    dispatch({
      type: 'SET_POPUPS',
      payload: {
        show_start_project: popups.showStartProject,
        // show_join_newsletter: popups.showNewsletter,
        show_cookies: popups.showCookies
      }
    })
  }, [popups]);

  const setShowStartProject = (status = true) => {
    dispatch({
      type: 'SET_POPUPS',
      payload: {
        show_start_project: status,
        // show_join_newsletter: state.show_join_newsletter,
        show_cookies: state.show_cookies
      }
    });
  }

  const setShowJoinNewsletter = (status = true) => {
    dispatch({
      type: 'SET_POPUPS',
      payload: {
        show_start_project: state.show_start_project,
        // show_join_newsletter: status,
        show_cookies: state.show_cookies
      }
    });
  }

  const setShowCookies = (status = true) => {
    dispatch({
      type: 'SET_POPUPS',
      payload: {
        show_start_project: state.show_start_project,
        // show_join_newsletter: state.show_join_newsletter,
        show_cookies: status
      }
    });
  }

  const getRandomPass = () => {
    return Math.floor(Math.random() * 10);
  }

  const setGetQuote = (status) => {
    dispatch({
      type: 'DATA',
      payload: {
        force_open_get_quote: status
      }
    });
  }

  const checkAndSetPopups = (what_should_be_shown = []) => {
    // const now = new Date().getTime();
    // const lastShowNewsletterTime = parseInt(localStorage.getItem('lastShowNewsletterTime')) || 0;
    // const lastShowStartProjectTime = parseInt(localStorage.getItem('lastShowStartProjectTime')) || 0;
    // const cookiesAccepted = localStorage.getItem('cookiesAccepted') === 'true';

    // const shouldShowNewsletter = now - lastShowNewsletterTime > (3 * 24 * 60 * 60 * 1000); // 3 days
    // const shouldShowStartProject = now - lastShowStartProjectTime > (7 * 24 * 60 * 60 * 1000); // 7 days
    // const shouldShowCookies = !cookiesAccepted;

    // setPopups({
    //   showNewsletter: shouldShowNewsletter,
    //   showStartProject: shouldShowStartProject,
    //   showCookies: shouldShowCookies,
    // });

    // if (shouldShowCookies && !cookiesAccepted) {
    //   localStorage.setItem('cookiesAccepted', 'true');
    // }

    const cookiesAccepted = cookies[CookiesList.cookiesAccepted] === 'true';
    const shouldShowCookies = !cookiesAccepted;

    if(what_should_be_shown.indexOf('cookie') > -1) {
      setPopups({
        showNewsletter: popups.showNewsletter,
        showStartProject: popups.showStartProject,
        showCookies: shouldShowCookies,
      });
      return;
    }

    console.log("XX")

    const now = new Date().getTime();
    const lastShowNewsletterTime = parseInt(localStorage.getItem('lastShowNewsletterTime')) || 0;
    const lastShowStartProjectTime = parseInt(localStorage.getItem('lastShowStartProjectTime')) || 0;

    let shouldShowNewsletter = now - lastShowNewsletterTime > (6 * 24 * 60 * 60 * 1000); // 6 days
    let shouldShowStartProject = now - lastShowStartProjectTime > (13 * 24 * 60 * 60 * 1000); // 13 days

    console.log(`
    Should show newsletter: ${shouldShowNewsletter},
    Should show start project: ${shouldShowStartProject}
      `)

    if(shouldShowNewsletter) {
      let pass = getRandomPass();
      console.log("Show newsletter pass :: ", pass)
      if(pass > 5) {
        shouldShowNewsletter = true;
      }
      else
      {
        shouldShowNewsletter = false;
      }
    }

    if(!what_should_be_shown.includes('newsletter') && shouldShowNewsletter) {
      shouldShowNewsletter = false;
    }

    if(shouldShowStartProject) {
      if(getRandomPass() > 5) {
        shouldShowStartProject = true;
      }
      else
      {
        shouldShowStartProject = false;
      }
    }


    if(!what_should_be_shown.includes('start_project') && shouldShowStartProject) {
      shouldShowStartProject = false;
    }

    console.log(`
      Should show newsletter: ${shouldShowNewsletter},
      Should show start project: ${shouldShowStartProject}
        `)

    setPopups({
      showNewsletter: shouldShowNewsletter,
      showStartProject: shouldShowStartProject,
      showCookies: state.open_popups.show_cookies,
    });

  };

  const set_nav_mode = (mode) => {
    dispatch({
      type: 'SET_NAV_MODE',
      payload: {
        navigation_mode: mode
      }
    });
  }

  const set_page_scroll = (ps) => {
    dispatch({
      type: 'SET_PAGESCROLL',
      payload: {
        page_scroll: ps
      }
    });
  }

  const setShowCookieAccepted = () => {
    setCookie(CookiesList.cookiesAccepted, true);
  }

  const toggleShowStartProjectDialog = (status) => {
    dispatch({
      type: 'SET_POPUPS',
      payload: {
        show_start_project: status,
        // show_join_newsletter: state.show_join_newsletter,
        show_cookies: state.show_cookies
      }
    });
    localStorage.setItem('lastShowStartProjectTime', new Date().getTime().toString());
  }

  const toggleShowNewsletterDialog = (status) => {
    dispatch({
      type: 'SET_POPUPS',
      payload: {
        show_start_project: state.show_start_project,
        // show_join_newsletter: status,
        show_cookies: state.show_cookies
      }
    });
    localStorage.setItem('lastShowNewsletterTime', new Date().getTime().toString());
  }

  const getUser = async () => {
    let token = cookies[CookiesList.accessToken];

    if (token) {
      if (req_controllers.me) {
        req_controllers.me.abort();
      }
      req_controllers.me = new AbortController();
      let response = await AuthService.me({
        signal: req_controllers.me.signal,
      });

      if (response.status && response.status === 200) {
        return {
          authenticated: true,
          user: response.data,
        };
      }
    }

    return {
      authenticated: false,
    };
  };

  const askApi = async (data, question, expectedAnswerType) => {
    if (!data || data.length < 1) {
      return;
    }
    let response = await AuthService.ask({
      data: data,
      questions: [
        {
          question: question,
          type: expectedAnswerType,
        },
      ],
    });
    if (response.status === 200) {
      dispatch({
        type: "ASK",
        payload: {
          question: question,
          answers: response.data,
          error: false,
        },
      });
    } else {
      dispatch({
        type: "ASK",
        payload: {
          question: question,
          answers: {},
          error: true,
        },
      });
    }
  };

  const redirectAfterLogin = () => {
    window.location.href = "/";
  };

  const saveAccessToken = (token, redirect = true) => {
    setCookie(CookiesList.accessToken, token, {
      path: "/",
      expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000), // 365 days
    });
    if (redirect) {
      setTimeout(() => {
        redirectAfterLogin();
      }, 20);
    }
  };

  const logout = (redirect = true) => {
    removeCookie(CookiesList.accessToken);
    if (redirect) {
      setTimeout(() => {
        window.location.href = "/";
      }, 20);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        saveAccessToken,
        logout,
        askApi,
        setShowCookieAccepted,
        toggleShowStartProjectDialog,
        toggleShowNewsletterDialog,
        set_page_scroll,
        set_nav_mode,
        setGetQuote
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

const useAuth = () => useContext(AuthContext);

export { AuthContext, AuthProvider, useAuth };
